export default __webpack_public_path__ + "static/luke-stackpoole--J1Z32zolUY-unsplash-40dfcbc080eda015d42f99973537e907.jpg";